import React from 'react';
import { SvgIcon } from '@mui/material';

// A compact, code-native rendering of the Microsoft Excel mark. Keeping the
// recognizable Excel green is intentional: at toolbar scale, brand color
// communicates the integration faster than a generic spreadsheet glyph.
export default function MicrosoftExcelIcon(props) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path fill="#107C41" d="M8 3h12.25A1.75 1.75 0 0 1 22 4.75v14.5A1.75 1.75 0 0 1 20.25 21H8z" />
            <path fill="#33C481" d="M13.5 3H20a2 2 0 0 1 2 2v3.25h-8.5z" />
            <path fill="#21A366" d="M13.5 8.25H22v4.5h-8.5z" />
            <path fill="#107C41" d="M13.5 12.75H22v4.5h-8.5z" />
            <path fill="#185C37" d="M13.5 17.25H22V19a2 2 0 0 1-2 2h-6.5z" />
            <path fill="#fff" fillOpacity=".9" d="M14.25 4.5h2.75v2.25h-2.75zm4 0H21v2.25h-2.75zm-4 5.25h2.75V12h-2.75zm4 0H21V12h-2.75zm-4 4.5h2.75v2.25h-2.75zm4 0H21v2.25h-2.75zm-4 4.25h2.75v1h-2.75zm4 0H21v1h-2.75z" />
            <path fill="#185C37" d="M2 6.15 13.5 4.5v15L2 17.85z" />
            <path fill="#fff" d="m5.15 9.1 1.85-.12 1.18 2.18 1.27-2.35 1.82-.12-2.02 3.35 2.08 3.42-1.9-.13L8.1 12.9l-1.28 2.2-1.82-.13 2.03-3.08z" />
        </SvgIcon>
    );
}
